<template>
  <layout-default>
    <div class="policy-page container">
      <header class="policy-header">
        <h1>Privacy Policy</h1>
        <p>
          This page explains how we collect, use, and safeguard information when you interact with Viabrera
          services.
        </p>
      </header>

      <section class="policy-section">
        <h2>Information We Collect</h2>
        <p>
          We collect information you provide directly, such as profile details, purchase information, and
          communications with our team. Technical information such as device identifiers, cookies, and usage
          statistics is gathered to keep our platform secure and reliable.
        </p>
      </section>

      <section class="policy-section">
        <h2>How We Use Information</h2>
        <p>
          Your information helps us operate the marketplace, personalize experiences, process payments, detect
          fraud, and comply with legal obligations. We never sell personal information and only share it with
          trusted processors who support our operations.
        </p>
      </section>

      <section class="policy-section">
        <h2>Your Choices</h2>
        <p>
          You may update your profile, request data exports, or ask us to delete your information by contacting
          our support team. Marketing emails always include an unsubscribe option, and cookie preferences can be
          managed through your browser.
        </p>
      </section>
    </div>
  </layout-default>
</template>

<script>
import LayoutDefault from "../../components/organisms/LayoutDefault/LayoutDefault.vue";

export default {
  name: "PrivacyPolicy",
  components: { LayoutDefault },
  created() {
    document.title = "Privacy Policy - viabrera";
  },
};
</script>

<style scoped>
.policy-page {
  padding: 60px 0 120px;
  color: #1f1f1f;
}

.policy-header {
  margin-bottom: 40px;
  text-align: left;
}

.policy-header h1 {
  font-size: clamp(2rem, 4vw, 2.8rem);
  margin-bottom: 12px;
}

.policy-header p {
  max-width: 720px;
  margin: 0;
  color: #5b5b5b;
  line-height: 1.6;
}

.policy-section + .policy-section {
  margin-top: 32px;
}

.policy-section h2 {
  font-size: 1.5rem;
  margin-bottom: 12px;
}

.policy-section p {
  margin: 0;
  line-height: 1.7;
  color: #3c3c3c;
}
</style>
